import { Directive, ElementRef, HostListener } from '@angular/core'

@Directive({
  selector: '[appAutoHeight]'
})
export class AutoHeightDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event.target'])
  onInput(textarea: HTMLInputElement): void {
    this.adjustHeight(textarea)
  }

  ngAfterViewInit(): void {
    this.adjustHeight(this.el.nativeElement)
    this.setResizable(false)
  }

  private adjustHeight(textarea: HTMLInputElement): void {
    textarea.style.overflow = 'hidden'
    textarea.style.height = 'auto'
    textarea.style.height = textarea.scrollHeight + 'px'
  }

  private setResizable(resizable: boolean): void {
    if (!resizable) {
      this.el.nativeElement.style.resize = 'none'
    } else {
      this.el.nativeElement.style.resize = 'both'
    }
  }
}
